import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import LabelCheckbox from '../../components/controls/LabelCheckbox'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'
import WykazJednostekSkonsolidowaneStyle from '../../styles/WykazJednostekSkonsolidowaneStyle'
import AnimateHeight from 'react-animate-height'
import logo from '../../assets/images/szambelan_jednostki_inne.svg'
import PrintText from '../../lib/PrintText'

class WykazJednostekInnych extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: -1,
      bilans: props.section.Dane.Pozycje.map((x) =>
        x.WysokoscKapitalu ? true : false,
      ),
      udzial: props.section.Dane.Pozycje.map(
        (x) => x.UdzialWKapitale !== x.UdzialWLiczbieGlosow,
      ),
    }
  }

  handleBilansChange = (e, index) => {
    let x = [...this.state.bilans]
    x[index] = e.target.checked
    this.setState({ bilans: x })
  }

  handleUdzialChange = (e, index) => {
    let x = [...this.state.udzial]
    x[index] = e.target.checked
    this.setState({ udzial: x })
  }

  handleToggleActive = (index) => {
    this.setState({ activeIndex: index })
  }

  handleAdd = (structure, sIndex) => {
    this.setState({
      bilans: [...this.state.bilans, false],
      udzial: [...this.state.udzial, false],
    })
    this.props.onAddDetailInfo(structure, sIndex)
  }

  render() {
    const {
      onSetSectionDataArray,
      section,
      validityErrors,
      czyPodsumowanie,
    } = this.props
    const struktura = {
      Nazwa: '',
      NazwaPodporzadkowane: '',
      WysokoscKapitalu: '',
      UdzialWKapitale: 0,
      UdzialWLiczbieGlosow: 0,
    }
    return (
      <MainStyle
        className={section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'}
      >
        <WykazJednostekSkonsolidowaneStyle>
          <div className="site-header high-emphasis-subtitle-1">
            <span>WYKAZ JEDNOSTEK INNYCH NIŻ JEDNOSTKI PODPORZĄDKOWANE</span>
            <ButtonAddInfo
              label="DODAJ JEDNOSTKĘ"
              structure={struktura}
              handleAdd={this.handleAdd}
            />
          </div>
          {section.Dane.Pozycje.length > 0 ? (
            <div className="container">
              <div className="list-header caption">
                <p>
                  NAZWA I SIEDZIBA JEDNOSTKI, W KTÓREJ JEDNOSTKI PODPORZĄDKOWANE
                  POSIADAJĄ ZAANGAŻOWANIE W KAPITALE
                </p>
              </div>
              {section.Dane.Pozycje.map((data, index) => (
                <ExpandableListElement
                  placeholder="Nazwa i siedziba jednostki innej niż podporządkowana"
                  nazwaPozycji={data.Nazwa}
                  isActive={this.state.activeIndex === index}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(validityErrors, name, value, true)
                  }
                >
                  <div className="header">
                    <p>SZCZEGÓŁY</p>
                  </div>
                  <form autoComplete="off" className="subsection">
                    {czyPodsumowanie ? (
                      <PrintText
                        text={data.NazwaPodporzadkowane}
                      />
                    ) : (
                      <TextField
                        className="textarea"
                        name="NazwaPodporzadkowane"
                        multiline
                        variant="outlined"
                        label="Nazwy i siedziby jednostek podporządkowanych posiadających zaangaż. w kapitale jednostki innej niż jednostki podporządkowane"
                        value={data.NazwaPodporzadkowane}
                        error={controlHasError(
                          validityErrors,
                          'NazwaPodporzadkowane',
                          data.NazwaPodporzadkowane,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                        onFocus={() => this.handleToggleActive(index)}
                        onBlur={() => this.handleToggleActive(-1)}
                      />
                    )}
                    <div className="oneLine">
                      <LabelCheckbox
                        name="CzyOgloszonoBilans"
                        label="Bilans jednostki jest ogłaszany"
                        value={this.state.bilans[index]}
                        change={(e) => this.handleBilansChange(e, index)}
                      />
                    </div>
                    {!czyPodsumowanie ? (
                      <AnimateHeight
                        duration={250}
                        height={this.state.bilans[index] ? 'auto' : 0}
                      >
                        <TextField
                          className="textarea"
                          name="WysokoscKapitalu"
                          multiline
                          variant="outlined"
                          label="Wysokość kapitału (funduszu) podst. oraz wysokość zatwierdzonego wyniku finansowego tych jednostek za ostatni rok obrotowy"
                          value={data.WysokoscKapitalu}
                          error={controlHasError(
                            validityErrors,
                            'WysokoscKapitalu',
                            data.WysokoscKapitalu,
                            true,
                          )}
                          onChange={(e) => onSetSectionDataArray(e, index)}
                          onFocus={() => this.handleToggleActive(index)}
                          onBlur={() => this.handleToggleActive(-1)}
                        />
                      </AnimateHeight>
                    ) : (
                      this.state.bilans[index] && (
                        <PrintText
                          text={data.WysokoscKapitalu}
                        />
                      )
                    )}
                    <div className="oneLine">
                      <span>
                        Udział w kapitale (funduszu) podstawowym i wyniku
                        finansowym netto za ostatni rok obrotowy:
                      </span>
                      <TextField
                        className="numericField"
                        placeholder="Udział"
                        name="UdzialWKapitale"
                        value={data.UdzialWKapitale}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                      />
                    </div>
                    <div className="oneLine">
                      <LabelCheckbox
                        name="CzyUdzialRozny"
                        label="Udział w całkowitej liczbie głosów jest różny od udziału w kapitale (funduszu) podstawowym"
                        value={this.state.udzial[index]}
                        change={(e) => this.handleUdzialChange(e, index)}
                      />
                      {this.state.udzial[index] ? (
                        <>
                          <p>Udział w całkowitej liczbie głosów:</p>
                          <TextField
                            className="numericField"
                            placeholder="Udział"
                            name="UdzialWLiczbieGlosow"
                            value={data.UdzialWLiczbieGlosow}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  %
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) => onSetSectionDataArray(e, index)}
                          />
                        </>
                      ) : null}
                    </div>
                  </form>
                </ExpandableListElement>
              ))}
            </div>
          ) : (
            <Szambelan
              logo={logo}
              text={
                <>
                  Brak informacji o jednostkach innych
                  <br /> niż jednostki podporządkowane
                </>
              }
            />
          )}
        </WykazJednostekSkonsolidowaneStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
          (value) => value.TypSekcji === 'WykazJednostekInnych',
        )
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionDataArray: (e, index) => {
      let { value, name } = e.target
      if (name === 'UdzialWKapitale' || name === 'UdzialWLiczbieGlosow')
        value = value.replace(',', '.')
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
    onAddDetailInfo: (structure, sIndex) => {
      return dispatch(actions.addDetailInfo(structure, sIndex))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WykazJednostekInnych)
